/**
 * Generated by orval v6.29.0 🍺
 * Do not edit manually.
 * Cloudsaver.Customers.Host.Api
 * OpenAPI spec version: 1.0
 */

export type PostCWMetricsConfigSaveCWMetricsConfigFiltersAppType = typeof PostCWMetricsConfigSaveCWMetricsConfigFiltersAppType[keyof typeof PostCWMetricsConfigSaveCWMetricsConfigFiltersAppType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostCWMetricsConfigSaveCWMetricsConfigFiltersAppType = {
  IdleResources: 'IdleResources',
  RightSizing: 'RightSizing',
} as const;
